import { render, staticRenderFns } from "./RecordPresenter.vue?vue&type=template&id=545dcc90&scoped=true"
import script from "./RecordPresenter.vue?vue&type=script&lang=js"
export * from "./RecordPresenter.vue?vue&type=script&lang=js"
import style0 from "./RecordPresenter.vue?vue&type=style&index=0&id=545dcc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545dcc90",
  null
  
)

export default component.exports